import { render, staticRenderFns } from "./FormEditGlobal.vue?vue&type=template&id=5d396484&scoped=true&"
import script from "./FormEditGlobal.vue?vue&type=script&lang=js&"
export * from "./FormEditGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d396484",
  null
  
)

export default component.exports